<template>
  <div class="c-footer" :class="{'c-footer--top': isTop}">
    <footer v-if="isTop" class="c-footerTop">
      <div class="c-lang c-lang--top f-ITC-BoldIt" :class="{'isHide': this.isFirst, 'isShow1': isShow1}">
        <ul>
          <li>LANG</li>
          <li><span>JP</span><a href="/en/">EN</a><a href="/kr/">KR</a></li>
        </ul>
      </div>

      <div class="c-footerTop__links" :class="{'isHide': this.isFirst, 'isShow1': isShow1}">
        <div v-if="ticker.is_show==='on'" class="is-info">
          <a :href="ticker.url">{{ticker.title}}</a>
        </div>
        <ul class="f-ITC-BoldIt">
          <li class="is-privacy"><a href="/privacy-policy/">PRIVACY POLICY</a></li>
          <li><a href="/contact/">CONTACT</a></li>
          <li><a href="/recruit/">RECRUIT</a></li>
          <li>
            <a class="c-footerTop__links__access" href="/company/?anchor=p-company__info"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 13" width="10" height="13">
              <path d="M5.008,13.000 C5.008,13.000 0.000,8.005 0.000,6.000 C0.000,3.246 1.990,0.982 5.008,0.982 C8.026,0.982 10.000,3.202 10.000,6.000 C10.000,8.040 5.008,13.000 5.008,13.000 M5.000,4.000 C6.105,4.000 7.000,4.895 7.000,6.000 C7.000,7.105 6.105,8.000 5.000,8.000 C3.895,8.000 3.000,7.105 3.000,6.000 C3.000,4.895 3.895,4.000 5.000,4.000 Z"/>
            </svg>ACCESS</a>
          </li>
        </ul>
      </div>
    </footer>
    <footer v-if="!isTop" class="c-footerCmn">
      <div class="c-footerCmn__wrap1">
        <a class="c-footerCmn__wrap1Logo" href="/">
          <img :src="`${assets_path}img/common/logo-pics.svg`" alt="P.I.C.S" width="184" height="40" />
        </a>

        <address class="c-footerCmn__wrap1Address">
          <ul>
            <li>ACCESS：<br class="u-none-b--sp">東京都渋谷区恵比寿南3-9-19 サイシンビル<a class="c-btnMap" :href="urls.map" target="_blank" rel="noopener"><span>MAP</span></a></li>
          </ul>
          <div class="c-footerCmn__wrap1LogoImagica">
            <a href="https://www.imagicagroup.co.jp/" target="_blank">
              <img :src="`${assets_path}img/common/logo-imagica.png`" alt="IMAGICA GROUP" width="240" height="39" />
            </a>
          </div>
        </address>
      </div>

      <div class="c-footerCmn__wrap2">
        <ul class="c-footerCmn__wrap2Pages f-ITC-BoldIt">
          <li><a href="/news/">NEWS</a></li>
          <li><a href="/works/">WORKS</a></li>
          <li><a href="/insights/">INSIGHTS</a></li>
          <li><a href="/member/">MEMBER</a></li>
          <li><a href="/creator/">CREATOR</a></li>
          <li><a href="/company/">COMPANY</a></li>
          <li><a href="/recruit/">RECRUIT</a></li>
          <li><a href="/contact/">CONTACT</a></li>
        </ul>
      </div>

      <div class="c-footerCmn__wrap3">
        <a class="c-footerCmn__wrap3Privacy" href="/privacy-policy/">PRIVACY POLICY</a>
        <ul class="c-footerCmn__wrap3Sns">
          <li><a class="c-btnFacebook c-btnFacebook--hoverBg" :href="urls.facebook" target="_blank" rel="noopener"></a></li>
          <li><a class="c-btnTwitter c-btnTwitter--hoverBg" :href="urls.twitter" target="_blank" rel="noopener"></a></li>
          <li><a class="c-btnInsta c-btnInsta--hoverBg" :href="urls.insta" target="_blank" rel="noopener"></a></li>
          <li><a class="c-btnYoutube c-btnYoutube--hoverBg" :href="urls.youtube" target="_blank" rel="noopener"></a></li>
        </ul>
      </div>

      <div class="c-footerCmn__cr">
        <small>Copyright © P.I.C.S. Co., Ltd. All Rights Reserved.</small>
      </div>
    </footer>
  </div>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';

  export default {
    data() {
      return {
        assets_path: assets_path,
        urls: {},
        isTop: false,
        isFirst: false,
        isShow1: false
      }
    },
    props: ['ticker'],
    store,
    created() {
      // 初回サイトアクセスとTOPページを判定
      this.$store.commit('setFirst');
      this.$store.commit('setTop');
      this.isFirst = this.$store.getters.getFirst;
      this.isTop = this.$store.getters.getTop;
      this.isTicker = document.getElementById('c-tickerSp') ? true : false;

// console.log(this.isFirst, this.isTicker);
      if (!this.isFirst && this.isTicker) {
        this.showTicker();
      }
    },
    mounted() {
      this.urls = this.$store.getters.getUrls;
    },
    methods: {
      showUI() {
        this.isShow1 = true;
        if (this.isTicker) this.showTicker();
      },
      showTicker() {
        //c-tickerSp
        document.documentElement.classList.add('is-show-ticker');
      }
    }
  }
</script>
